import { createContext } from "react";
import { DefaultLogger, Logger } from "../../logger";
import { ServiceInterface } from "../service.interface";

export const LoggerServiceContext = createContext<LoggerService>(null as any);

// Implementation of logger service is equal to the application logger
export class LoggerService extends Logger implements ServiceInterface {
  public context = LoggerServiceContext;
}

export const useLogger = () => {
  return DefaultLogger;
};
